import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import TileScroller from '@zola/zola-ui/src/components/TileScroller';

import { EA_PATH } from 'constants/expertAdvice';

import { NextUpPostType, PageTypes, PostType } from 'libs/contentful/types';

import { DESKTOP_MIN, LG_DESKTOP_MIN, TABLET_MIN } from 'libs/universal/utils/device';
import {
  CarouselContainer,
  CarouselTitle,
  CarouselTitleContainer,
  TileHeading,
  TileImage,
  TileImageContainer,
  TileLink,
  TileParagraph,
  TileTag,
  TileTextContainer,
} from './FeaturedArticlesCarousel.styles';

type FeaturedArticlesCarouselProps = {
  articles: PageTypes[] | NextUpPostType[];
  title?: string;
  viewAllHref?: string;
};

const FeaturedArticlesCarousel = ({
  articles,
  title,
  viewAllHref,
}: FeaturedArticlesCarouselProps): JSX.Element => {
  return articles.length > 0 ? (
    <CarouselContainer>
      <CarouselTitleContainer>
        <CarouselTitle>{title || 'Featured'}</CarouselTitle>
        {viewAllHref ? (
          <ButtonV3 component="a" href={viewAllHref}>
            View all
          </ButtonV3>
        ) : (
          <></>
        )}
      </CarouselTitleContainer>
      <TileScroller>
        {articles.map((article, i) => {
          const { heroImage = {}, slug, title: articleTitle } = article;
          const { excerpt, tag } = article as PostType;
          return (
            <TileLink href={`${EA_PATH}/${slug}`} key={i}>
              <TileImageContainer>
                <TileImage
                  alt={heroImage.altText || ''}
                  src={heroImage.src || ''}
                  breakpointWidthMap={{
                    1: 150,
                    [TABLET_MIN]: 182,
                    [DESKTOP_MIN]: 270,
                    [LG_DESKTOP_MIN]: 350,
                  }}
                  loading="lazy"
                />
              </TileImageContainer>
              <TileTextContainer>
                <TileHeading presentation="h6">{articleTitle}</TileHeading>
                {tag ? <TileTag>{tag}</TileTag> : <></>}
                {excerpt ? <TileParagraph>{excerpt}</TileParagraph> : <></>}
              </TileTextContainer>
            </TileLink>
          );
        })}
      </TileScroller>
    </CarouselContainer>
  ) : (
    <></>
  );
};

export default FeaturedArticlesCarousel;
